import React, { Dispatch } from "react";
import Modal from "../Modal";
import { useFormik } from "formik";
import Input from "../../../generic/dataEntry/Input/Input";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux";
import {
  addClient,
  fetchClients,
  getClient,
  setCurrentPage,
  updateClient,
} from "../../../../store/actions/clientActions";
import { clientSlice } from "../../../../store/slices/clientSlice";
import CustomDatePicker from "../../../generic/dataEntry/CustomDatePicker/CustomDatePicker";
import { IClient } from "../../../../models/client";
import classes from "../Modal/Modal.module.scss";

interface IAddClientModalProps {
  close: any;
  children?: string | JSX.Element | JSX.Element[];
  editSuccess: Dispatch<any>;
  editableItem?: IClient;
}

export default function ModalEditClient({
  close,
  editSuccess,
  editableItem,
}: IAddClientModalProps) {
  const dispatch = useAppDispatch();
  const { error, pageSize, isUpdating, isAdding, currentPage } = useAppSelector(
    (state) => state.client
  );
  const modalTitle = editableItem
    ? "Редактировать клиента"
    : "Добавить клиента";

  const initialFormValues = editableItem
    ? {
        client_uuid: editableItem.client_uuid,
        fio: editableItem.fio,
        phone: editableItem.phone,
        birthday: editableItem.birthday,
        height: editableItem.height,
        weight: editableItem.weight,
      }
    : {
        fio: "",
        phone: "",
        birthday: "",
        height: "",
        weight: "",
      };

  const { values, touched, handleChange, handleReset } = useFormik({
    initialValues: initialFormValues,
    onSubmit: () => {},
  });

  const inputChangeHandler = (e: React.ChangeEvent) => {
    handleChange(e);
    const fieldName: any = e.target.getAttribute("name");

    if (error[fieldName]) {
      dispatch(clientSlice.actions.clearFieldError(fieldName));
    }
  };

  const dateChangeHandler = (date: string, name: string) => {
    handleChange({
      target: { name, value: date },
    });

    if (error[name]) {
      dispatch(clientSlice.actions.clearFieldError(name));
    }
  };

  const saveHandler = async () => {
    const clientID = await dispatch(addClient(values));

    if (clientID) {
      dispatch(setCurrentPage(1));
      await dispatch(fetchClients({ page: 1, pageSize }));
      close();
      editSuccess(true);
      handleReset(initialFormValues);
    }
  };

  const updateHandler = async () => {
    const isUpdated = await dispatch(updateClient(values));

    if (isUpdated) {
      editSuccess(true);
      dispatch(setCurrentPage(1));
      await dispatch(fetchClients({ page: 1, pageSize }));

      if (editableItem?.client_uuid)
        await dispatch(getClient({ client_uuid: editableItem.client_uuid }));

      close();
      handleReset(initialFormValues);
    }
  };

  const closeHandler = () => {
    close();
    dispatch(clientSlice.actions.clearAllErrors());
  };

  const commonErrorMessage = Object.keys(error).length > 0 && (
    <div className={classes.form_common_error}>
      * Не заполнены обязательные поля
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      close={closeHandler}
      dialogSizeSuffix={"w620"}
      submitClick={editableItem ? updateHandler : saveHandler}
      cancelClick={closeHandler}
      submitDisabled={isUpdating || isAdding}
      submitLoading={isUpdating || isAdding}
    >
      <form className={classes.form}>
        <div className={classes.form_group}>
          <div className={classes.form_field}>
            <Input
              value={values.fio}
              onChange={(e: React.ChangeEvent) => {
                inputChangeHandler(e);
              }}
              name={"fio"}
              label={"Полное имя (ФИО)"}
              valid={!error.fio}
              touched={touched.fio}
              required
              shouldValidate
            />
          </div>
          <div
            className={[
              classes.form_group_container,
              classes.form_group_container_client_data,
            ].join(" ")}
          >
            <div className={classes.form_field}>
              <Input
                mask="+7 (999) 999-99-99"
                value={values.phone}
                onChange={(e: React.ChangeEvent) => {
                  inputChangeHandler(e);
                }}
                name={"phone"}
                label={"Телефон"}
                valid={!error.phone}
                touched={touched.phone}
                required
                shouldValidate
              />
            </div>
            {/*Feat: Скрыли       
             <div className={classes.form_field}>
              <CustomDatePicker
                curDate={values.birthday}
                onChangeDate={(date: string) => {
                  dateChangeHandler(date, "birthday")
                }}
                name={"birthday"}
                label={"Дата рождения"}
                required
                shouldValidate
                valid={!error.birthday}
                touched={touched.birthday}
              />
            </div>
            <div className={classes.form_field}>
              <Input
                value={values.height}
                onChange={(e: React.ChangeEvent) => {
                  inputChangeHandler(e)
                }}
                name={"height"}
                label={"Рост (см)"}
                valid={!error.height}
                touched={touched.height}
                required
                shouldValidate
              />
            </div> */}
            <div className={classes.form_field}>
              <Input
                value={values.weight}
                onChange={(e: React.ChangeEvent) => {
                  inputChangeHandler(e);
                }}
                name={"weight"}
                label={"Вес (кг)"}
                valid={!error.weight}
                touched={touched.weight}
                required
                shouldValidate
              />
            </div>
          </div>
        </div>
        {commonErrorMessage}
      </form>
    </Modal>
  );
}
